import { FullHeader } from "./FullHeader";
import { LogoHeader } from "./LogoHeader";
import { MinimalHeader } from "./MinimalHeader";

export type HeaderStyleProps = {
  inverse?: boolean;
  overlay?: boolean;
  multicolor?: boolean;
};

type HeaderType = "full" | "logo" | "minimal";

type MinimalHeaderProps = {
  type: Extract<HeaderType, { kind: "minimal" }>;
  title: string;
  cta?: string;
};

export type HeaderProps = HeaderStyleProps &
  (
    | MinimalHeaderProps
    | ({ type?: HeaderType } & Omit<Partial<MinimalHeaderProps>, "type">)
  );

export const Header = ({
  inverse = true,
  overlay = false,
  multicolor = false,
  type = "full",
  title,
  cta,
}: HeaderProps) => {
  if (type === "logo") {
    return <LogoHeader inverse={inverse} overlay={overlay} />;
  }

  if (type === "minimal") {
    return (
      <MinimalHeader
        inverse={inverse}
        overlay={overlay}
        title={title}
        cta={cta}
      />
    );
  }

  return (
    <FullHeader inverse={inverse} overlay={overlay} multicolor={multicolor} />
  );
};
